import { createSlice } from '@reduxjs/toolkit'

//pull all redux data from local storage that way its all here when a user reopens their app
const initialState = {
  reduxIsLoggedIn:window.localStorage.getItem('loggedIn'),
  reduxUserName:window.localStorage.getItem('username'),
  reduxUserPhoto:window.localStorage.getItem('userPhoto'), //until we put in the photo thing on "sign up"
  reduxUserID:'temp', //have the ID start as something. if its nothing or a localStorage value thats not set, DB calls will break
  //this way the calls will fail but the calls can still fire, until the ID is set
}

export const isLoggedInSlice = createSlice({
  name: 'counter', //its not this that names the reducer for import in store. WTF?!
  initialState,
  reducers: {
    setLoginStatus: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.reduxIsLoggedIn = action.payload
    },
    setPhoto: (state, action) => { 
      state.reduxUserPhoto = action.payload
    },
    setUserName: (state, action) => {
      state.reduxUserName = action.payload
    },
    setReduxUserID: (state, action) => {
      state.reduxUserID = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
//export const { increment, decrement, incrementByAmount } = counterSlice.actions
export const { setLoginStatus, setPhoto, setUserName,setReduxUserID } = isLoggedInSlice.actions
export default isLoggedInSlice.reducer